export const trimHtmlToTextLength = (html: string, limit = 1000) => {
  const container = document.createElement('div');
  container.innerHTML = html;
  let remaining = limit;

  /**
   * Depth‑first walk.  As soon as `remaining` hits 0,
   * delete everything that follows the current node.
   */
  function walk(node: Node) {
    if (remaining <= 0) {
      node.parentNode?.removeChild(node);
      return;
    }

    if (node.nodeType === Node.TEXT_NODE) {
      const len = (node as Text).data.length;
      if (len > remaining) {
        (node as Text).data = (node as Text).data.slice(0, remaining);
        remaining = 0;
      } else {
        remaining -= len;
      }
      return;
    }

    // Clone the child list because we may remove nodes while iterating
    const children = Array.from(node.childNodes);
    for (const child of children) {
      walk(child);
      if (remaining === 0) {
        // Remove ALL siblings after the child we just processed
        let sib = child.nextSibling;
        while (sib) {
          const next = sib.nextSibling;
          sib.parentNode?.removeChild(sib);
          sib = next;
        }
        break; // no need to keep walking siblings
      }
    }
  }

  walk(container);
  return container.innerHTML;
};
